import { render, staticRenderFns } from "./UserProducts.vue?vue&type=template&id=15567886&scoped=true"
import script from "./UserProducts.vue?vue&type=script&lang=js"
export * from "./UserProducts.vue?vue&type=script&lang=js"
import style0 from "./UserProducts.vue?vue&type=style&index=0&id=15567886&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15567886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15567886')) {
      api.createRecord('15567886', component.options)
    } else {
      api.reload('15567886', component.options)
    }
    module.hot.accept("./UserProducts.vue?vue&type=template&id=15567886&scoped=true", function () {
      api.rerender('15567886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/UserProducts.vue"
export default component.exports